import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import LandingPage from './views/LandingPage';
import ReservePage from './views/ReservePage';
import ReservePreviewPage from './views/ReservePreviewPage';
import ContactPage from './views/ContactPage';
import SuccessPage from './views/SuccessPage';
import CancelPage from './views/CancelPage';
import ReserveCancelPage from './views/ReserveCancelPage';
import MenuButton from './components/common/MenuButton';
import 'bootstrap/dist/css/bootstrap.min.css';
import AuthProvider from './context/AuthContext';
import Login from './views/Login';
import ProtectedRoute from './components/ProtectedRoute';
import Admin from './views/Admin';
import Users from './views/Users';
import Contacts from './views/Contacts';
import AvailableTimes from './views/AvailableTimes';
import Reservations from './views/Reservations';
import Articles from './views/Articles';
import ArticleEditor from './views/ArticleEditor';
import PrivacyPolicy from './views/PrivacyPolicy';
import LegalNotice from './views/LegalNotice';
import TermsOfService from './views/TermsOfService';
import ThreeDSecureCallback from './views/ThreeDSecureCallback';

const App = () => {
  return (
    <BrowserRouter>
      <Layout>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/reserve" element={<ReservePage />} />
            <Route path="/reserve-preview" element={<ReservePreviewPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/cancel" element={<ReserveCancelPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/logout" element={<div>ログアウトしました。</div>} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            {/* <Route path="/legal" element={<LegalNotice />} /> */}
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/3ds-callback" element={<ThreeDSecureCallback />} />
            {/* 管理者専用ページ */}
            <Route
              path="/admin"
              element={<ProtectedRoute element={<Admin />} />}
            />
            <Route
              path="/admin/users"
              element={<ProtectedRoute element={<Users />} />}
            />
            <Route
              path="/admin/contacts"
              element={<ProtectedRoute element={<Contacts />} />}
            />
            <Route
              path="/admin/available-times"
              element={<ProtectedRoute element={<AvailableTimes />} />}
            />
            <Route
              path="/admin/reservations"
              element={<ProtectedRoute element={<Reservations />} />}
            />
            <Route
              path="/admin/articles"
              element={<ProtectedRoute element={<Articles />} />}
            />
            <Route
              path="/admin/articles/new"
              element={<ProtectedRoute element={<ArticleEditor />} />}
            />
            <Route
              path="/admin/articles/:id/edit"
              element={<ProtectedRoute element={<ArticleEditor />} />}
            />
          </Routes>
          <MenuButton />
        </AuthProvider>
      </Layout>
    </BrowserRouter>
    // <GoogleOAuthProvider
    //   clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}
    // >
    //   <AuthProvider>
    //     <Router>
    //       <Routes>
    //         <Route path="/login" element={<Login />} />
    //         <Route path="/signup" element={<Signup />} />
    //         <Route path="/" element={<Top />} />
    //         <Route path="/privacy/policy" element={<PrivacyPolicy />} />
    //         <Route path="/delete/data" element={<DeleteData />} />
    //         {/* ログイン必須のページ */}
    //         <Route
    //           path="/mypage"
    //           element={<ProtectedRoute element={<MyPage />} />}
    //         />
    //         {/* <Route path="/settings" element={<ProtectedRoute element={<Settings />} />} /> */}
    //         <Route path="/logout" element={<div>ログアウトしました。</div>} />
    //         {/* 管理者専用ページ */}
    //         <Route
    //           path="/admin"
    //           element={<ProtectedRoute element={<Admin />} />}
    //         />
    //         <Route
    //           path="/admin/users"
    //           element={<ProtectedRoute element={<Users />} />}
    //         />
    //       </Routes>
    //       <MenuButton />
    //     </Router>
    //   </AuthProvider>
    // </GoogleOAuthProvider>
  );
};

export default App;
